import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { BaseResponse } from "../../../shared/models/base-api-response.interface";
import { endpoint, httpOptions } from "../../../shared/apis/endpoint";
import { environment as env } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class HcliniaService {
  constructor(private _http: HttpClient) {}

  RecetasPorPaciente(historia: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.HCLINICA_RECETAS}${historia}`;
    return this._http
      .get(requestUrl)
      .pipe(map((resp: any) => resp as BaseResponse));
  }

  MisEstudios(historia: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.HCLINICA_MIS_ESTUDIOS}${historia}`;
    return this._http
      .get(requestUrl)
      .pipe(map((resp: any) => resp as BaseResponse));
  }

  getUrlDescarga(rutayNombre: string): string {
    return `${env.api}${endpoint.HCLINICA_MIS_ESTUDIOS_DESCARGA}${encodeURIComponent(rutayNombre)}`;
  }
}
